module.exports = __webpack_public_path__ + "img/compilation.a8387d43.svg";